import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, inject, effect, ViewChild, } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/core/user.service';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2'
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { LOCALE_ID } from '@angular/core';
import { FilterModel } from './filter.model';
import { saveAs } from 'file-saver';
import { Workbook } from 'exceljs';
import { ActivatedRoute } from '@angular/router';
import { BudgetOverViewComponent } from '../budget-over-view/budget-over-view.component';
import { Chart, ChartConfiguration, ChartOptions, ChartType } from 'chart.js';
import { AppVariablesService } from '../../../service/app-variables.service';
import { NgChartsModule } from 'ng2-charts';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import jsPDF from 'jspdf'
import { DomSanitizer } from '@angular/platform-browser';
import autoTable from 'jspdf-autotable';




@Component({
  selector: 'app-summary-general',
  standalone: true,
  imports: [
    DecimalPipe,
    NgSelectModule,
    FormsModule,
    NgbModule,
    CommonModule,
    BudgetOverViewComponent,
    NgChartsModule,
  ],
  providers: [NgbModal, { provide: LOCALE_ID, useValue: 'es-ES' }],
  templateUrl: './summary-general.component.html',
  styleUrl: './summary-general.component.css',
})
export class SummaryGeneralComponent {
  @ViewChild('preview', { static: true }) preview: any;
  private modalRef: NgbModalRef;
  private userService = inject(UserService);
  public ngSelectedOld: string;
  public inputOld;
  public entitySelected: Entity;
  private budgetVersionSelected;
  public budgetGenerateService = inject(BudgetGenerateService);
  public accounts = [];
  public departament = [];
  public departamentTemp;
  public accountsTemp;
  public fieldName = [];
  public subtotal;
  public filter: FilterModel = new FilterModel();
  public navTab = 'dependientes';
  public rows = Array.from({ length: 15 }, (_, i) => i + 1);
  public cols = Array.from({ length: 4 }, (_, i) => i + 1);
  public isLoading = true;
  public title = 'Presupuesto';
  public selectedDepartament;
  public items;
  public budgetFund;
  public fundSelect;
  public itemsTemp;
  expensesTotalsByDept;
  EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  appVariables = this.appVariablesService.getAppVariables();
  public doughnutChartData: ChartConfiguration<'doughnut'>['data'] = {
    labels: [],
    datasets: [],
  };
  public doughnutChartOptions: ChartOptions<'doughnut'> = {};
  public doughnutChartLegend = true;
  public ChartDataLabels = ChartDataLabels;
  public importAasinet;
  public groupedAccounts;
  public groupedExpenses;
  collapseStates: { [key: string]: boolean } = {};
  public factorRea;
  public groupedExpensesDepartamentFund;
  dataChart;
  user;
  public pdfSrc

  customDidParseCell = (data) => {
    if (['head', 'foot'].includes(data.section)) {
      if (data.column.index === 0) data.cell.styles.halign = 'left';
      if ([1, 2].includes(data.column.index)) data.cell.styles.halign = 'center';
      if (data.column.index > 2) data.cell.styles.halign = 'right';
    }
  };
 

  datalabels = {
    formatter: (value: number, ctx) => {
      const sum = ctx.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
      const percentage = (value / sum) * 100;
      return percentage.toFixed(2) + '%';
    },
  };

  labelTooltip = {
    label: (context: any) => {
      const value = context.raw?.toFixed(2) + '%';
      return ` ${value}`;
    },
  };

  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private appVariablesService: AppVariablesService,
    private sanitizer: DomSanitizer
  ) {
    this.appVariablesService.variablesReload.subscribe(() => {
      this.appVariables = this.appVariablesService.getAppVariables();
      this.setChartOptions();
      this.renderDoughnutChart();
    });

    effect(() => {
      this.entitySelected = this.userService.sharingEntity();
      const user=this.userService.userData();
      this.budgetVersionSelected = this.userService.sharingBudgetVersion();
      const budgetFundData = this.userService.sharingBudgetFund();
      if (this.budgetVersionSelected?.year) {
        this.user=user;
        this.budgetFund = budgetFundData;
        this.fundSelect = this.budgetFund[0]?.fundCode;
        this.filter.year = this.budgetVersionSelected.year;
        this.filter.version = this.budgetVersionSelected.version;        
        this.getFactorRea();
        this.getResumen();
        this.getImportAasinet();
      }
    });
  }


  get columnStyles(): { [key: number]: { cellWidth: number; halign?: string } } {
    if (this.entitySelected?.group === 'IASD') {
      return {
        0: { cellWidth: 166 },
        1: { cellWidth: 40, halign: 'center' },
        2: { cellWidth: 55, halign: 'center' },
        3: { cellWidth: 77, halign: 'right' },
        4: { cellWidth: 77, halign: 'right' },
        5: { cellWidth: 85, halign: 'right' },
      };
    }
  
    return {
      0: { cellWidth: 200 },
      1: { cellWidth: 80, halign: 'center' },
      2: { cellWidth: 80, halign: 'center' },
      3: { cellWidth: 140, halign: 'right' },
    };
  }
  
 /*abre los modales */
 open(content) {
  this.modalRef = this.modalService.open(content,{ size: 'lg' });
}

 /*cierra los modales */
close() {
  if (this.modalRef) {
    this.modalRef.close();
  }
}
  setChartOptions() {
    Chart.defaults.font.family = this.appVariables.font.bodyFontFamily;
    Chart.defaults.font.size = 12;
    Chart.defaults.color = this.appVariables.color.bodyColor;
    Chart.defaults.borderColor = this.appVariables.color.borderColor;
    Chart.defaults.plugins.legend.display = false;
    Chart.defaults.plugins.datalabels = this.datalabels;
    Chart.defaults.plugins.tooltip.padding = {
      left: 8,
      right: 12,
      top: 8,
      bottom: 8,
    };
    Chart.defaults.plugins.tooltip.cornerRadius = 8;
    Chart.defaults.plugins.tooltip.titleMarginBottom = 6;
    Chart.defaults.plugins.tooltip.displayColors = true;
    Chart.defaults.plugins.tooltip.boxPadding = 6;
  }

  displayName(item: any) {
    return item?.map((item: any) => item.displayName);
  }

  percentage(item: any) {
    return item?.map((item: any) => item.percentage);
  }

  rgbaColor(item: any) {
    return item?.map((item: any) => item.rgbaColor);
  }

  hexColor(item: any) {
    return item?.map((item: any) => item.hexColor);
  }

  totalValue(){
    return this.entitySelected.group=='IASD'?this.findTitheTotal():this.getTotalRevenue(this.items?.revenueTotals);
  }

  buildDatachart(){
    const styleToRgbKey: Record<
        string,
        keyof typeof this.appVariables.color
      > = {
        'bg-primary': 'primaryRgb',
        'bg-info': 'infoRgb',
        'bg-purple': 'purpleRgb',
        'bg-indigo': 'indigoRgb',
        'bg-teal': 'tealRgb',
      };

      const styleToHexKey: Record<
        string,
        keyof typeof this.appVariables.color
      > = {
        'bg-primary': 'primary',
        'bg-info': 'info',
        'bg-purple': 'purple',
        'bg-indigo': 'indigo',
        'bg-teal': 'teal',
      };
    return this.groupedExpenses?.map((e) => {
        const rgbKey = styleToRgbKey[e.itemStyle] ?? 'primaryRgb';
        const hexKey = styleToHexKey[e.itemStyle] ?? 'primary';
        return {
          displayName: e.displayName,
          totalValue: e.totalValue,
          percentage: (e.totalValue * 100) / this.totalValue(),
          rgbaColor: `rgba(${this.appVariables.color[rgbKey]}, 0.75)`,
          hexColor: this.appVariables.color[hexKey],
        };
      });
  }

  renderDoughnutChart() {
    if (this.groupedExpenses) {
      this.setChartOptions();
      const expenses =this.groupedExpenses;
      let TotalRevenue=this.getTotalRevenue(this.items?.revenueTotals);
      let revenue=this.totalValue();
      const expensesTotal = this.getTotalExpense(this.items?.expenseTotals);
      const margin = ((TotalRevenue - expensesTotal) * 100) / revenue;
      

      this.dataChart = this.buildDatachart();

      this.doughnutChartData = {
        labels: [...this.displayName(this.dataChart), 'Margen'],
        datasets: [
          {
            data: [...this.percentage(this.dataChart), margin],
            labelsValues: [...this.percentage(this.dataChart), margin],
            backgroundColor: [
              ...this.rgbaColor(this.dataChart),
              'rgba(251, 85, 151, 0.75)',
            ],
            hoverBackgroundColor: [
              ...this.hexColor(this.dataChart),
              this.appVariables.color.pink,
            ],
            borderWidth: 0,
          } as any,
        ],
      };
      this.doughnutChartOptions = {
        color: this.appVariables.color.bodyColor,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
            const realPercentage = ctx.chart.data.datasets[0].labelsValues[ctx.dataIndex];
            return realPercentage.toFixed(2) + '%';
          },
          color: '#fff',
          } as any,
          tooltip: {
            callbacks: this.labelTooltip,
          },
        },
        scales: {},
        responsive: true,
        maintainAspectRatio: false,
        cutout: '60%', // para un estilo doughnut más limpio
      };
    }
  }
  ngOnInit() {

    
  
  }



  getFactorRea() {
    let filter = { ...this.filter };
    delete filter.departamentItemCode;
    this.budgetGenerateService.getFactorRea(filter).subscribe((res) => {
      this.factorRea = res;
    });
  }


  notification(title) {
    const Toast = Swal.mixin({
      icon: 'success',
      title: title,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
    Toast.fire();
  }

  findDepartament(departamentCode, departament, departamentFundCode) {
    return departament.find(
      (d) =>
        d.departamentCode == departamentCode &&
        d.departamentFundCode == departamentFundCode
    );
  }

  findGroupByParentCode(groups: any[], parentCode) {
    return groups.find((g) => g.parentCode == parentCode);
  }

  getValue(departamentCode, departaments, field, departamentFundCode) {
    return (
      departaments?.find(
        (d) =>
          d.departamentCode == departamentCode &&
          d.departamentFundCode == departamentFundCode
      )?.[field] ?? 0
    );
  }

  getSubTotalValue(departamentCode, field, departamentFundCode) {
    const subtotal = this.subtotal;

    return (
      subtotal.departaments?.find(
        (d) =>
          d.departamentCode == departamentCode &&
          d.fundCode == this.fundSelect &&
          d.departamentFundCode == departamentFundCode
      )?.[field] ?? 0
    );
  }
  calculateFactor() {
    if (!this.items) {
      return 0;
    }
    const totalTithe = this.items?.revenueTotals?.totalTithe;
    const totalNonTithe = this.items?.revenueTotals?.totalNonTithe;
    const total = this.items?.revenueTotals?.total;
    const factor = totalTithe / total;
    return factor;
  }

  getTotalFund() {
    return (
      this.subtotal?.funds?.find((f) => f.fundCode == this.fundSelect)
        ?.valueTotal ?? 0
    );
  }

  getImportAasinet() {
    let filter = { ...this.filter };
    delete filter.departamentItemCode;
    this.budgetGenerateService.getExportAasinet(filter).subscribe((res) => {
      this.importAasinet = res;
    });
  }

  /**trae los datos de los departamentos de la cuenta seleccionada */
  getResumen() {
    let filter = { ...this.filter };
    delete filter.departamentItemCode;
    this.budgetGenerateService.getResumen(filter).subscribe((res) => {
      this.items = res;
      this.itemsTemp = JSON.parse(JSON.stringify(this.items));
      this.isLoading = false;
       this.groupedAccountsWithPercent(this.items?.revenuesAccounts);
      this.groupedExpensesWithPercent(this.items?.expenses);
      this.groupedExpensesDepartamentFundCode(this.items?.expensesDepartamentFunds);
      this.expensesTotalsByDept=this.calculateDepartmentItemTotals(this.items);
        this.expensesTotalsByDept=this.orderByDepartament(this.expensesTotalsByDept);
      this.renderDoughnutChart();
     
      Swal.close();
    });
  }


  getValueRevenueDepartamentFund(accountParentCode,departamentFundCode) {
    return this.items?.revenuesAccounts?.find((d) => d.accountParentCode == accountParentCode && d.departamentFundCode == departamentFundCode)?.totalValue ?? 0;
  }


  getValueExpenseDepartamentFund(account,departamentFundCode) {
    return account?.departamentFund?.find((d) => d.departamentFundCode == departamentFundCode)?.totalValue ?? 0;
  }


  getTotalRevenue(revenueTotals: { fundCode: number; totalValue: number }[]): number {
    return revenueTotals?.reduce((acc, curr) => acc + (curr.totalValue || 0), 0) || 0;
  }

  getTotalExpense(expenseTotals: { fundCode: number; totalValue: number }[]): number {
    return expenseTotals?.reduce((acc, curr) => acc + (curr.totalValue || 0), 0) || 0;
  }


  orderByDepartament(expenses){
    return expenses.sort((a,b)=>a.departamentFundCode-b.departamentFundCode);
  }
  
  calculateDepartmentItemTotals(items) {
    const expenses=items?.expensesDepartamentFunds;
    let result=[];
    if (Array.isArray(expenses)) {
      
    const grouped = {};
  
    for (const expense of expenses) {
      const key = `${expense?.departamentFundCode}`;
      
      if (!grouped[key]) {
        grouped[key] = {
          ...expense,
          totalValue: 0 
        };
      }
  
      grouped[key].totalValue += Number(expense.totalValue ??0);
    }
  
    result=Object.values(grouped);
    }
    return result;
  }
  


  findTotalByDepartament(departamentFundCode){ 
    return this.expensesTotalsByDept?.find(i=>i.departamentFundCode==departamentFundCode)
  }


  groupedAccountsWithPercent(accounts) {
    const grouped: { 
      accountParentCode: number; 
      accountParentName: string; 
      totalValue: number; 
      departamentFundCode: number;
      percent?: number }[] = [];
    accounts.forEach(acc => {
      const existing = grouped.find(g => g.accountParentCode === acc.accountParentCode);
      if (existing) {
        existing.totalValue += acc.totalValue ?? 0;
      } else {
        grouped.push({
          accountParentCode: acc.accountParentCode,
          accountParentName: acc.accountParentName,
          departamentFundCode: acc.departamentFundCode,
          totalValue: acc.totalValue ?? 0
        });
      }
    });    
    this.calculatedPercent(grouped);
    this.groupedAccounts = grouped;
  }

  findTitheTotal(){
  return this.items?.revenuesDepartaments?.find(i=>i.code=='0001')?.totalValue;
}


   calculatedPercent(grouped) {
    let revenue=this.entitySelected.group=='IASD'?this.findTitheTotal():this.getTotalRevenue(this.items?.revenueTotals);
    return  grouped.forEach(g => {
      g.percent = revenue > 0 ? (g.totalValue * 100) / revenue : 0;
    });
  }


  groupedExpensesWithPercent(expenses) {
  
    const grouped: { code: string; displayName: string; totalValue: number; percent?: number; itemStyle?: string }[] = [];
  
    expenses?.forEach(exp => {
      const existing = grouped.find(g => g.code === exp.code);
      if (existing) {
        existing.totalValue += exp.totalValue ?? 0;
      } else {
        grouped.push({
          code: exp.code,
          displayName: exp.displayName,
          totalValue: exp.totalValue ?? 0,
          itemStyle: exp.itemStyle,
          
        });
      }
    });
    this.calculatedPercent(grouped);
    this.groupedExpenses = grouped;
  }


  findFactorRea(itemCode) {
    let result=this.factorRea?.find((f) => f.itemCode == Number(itemCode));
    return result;
  }




 
groupedExpensesDepartamentFundCode(data) {
  const map = new Map()
  if (Array.isArray(data)) {
  for (const item of data) {
    const key = item?.code;
    if (!map.has(key)) {
      map.set(key, []);
    }
    map.get(key)?.push(item);
  }

   this.totalAndPercentDepartamentFund(Array.from(map.entries()));
}
}

totalAndPercentDepartamentFund(maped){
  this.groupedExpensesDepartamentFund = maped.map(([code, departamentFund]) => {
    const total = departamentFund.reduce((sum, curr) => sum + (curr.totalValue ?? 0), 0);
    const percent = total > 0 ? (total * 100) / this.findTitheTotal() : 0;
    return {
      code,
      displayName:this.findFactorRea(code)?.displayName,
      departamentFund,
      totalValue:total,
      percent,
    };
  })
}


  

  findItem(itemCode) {
    return this.items?.expenses?.find((i) => i.itemCode == itemCode);
  }

  /**exportar excel */

  headers() {
    let headers = ['Cuenta', 'Nombre', 'Diezmo', 'No Diezmo'];
    const accountPlan = this.fieldName;
    return [...headers, ...this.headerAccounts(accountPlan)];
  }

  capitalize(value) {
    return value
      ?.toLowerCase()
      ?.split(' ')
      ?.map((word) =>
        word
          ?.split('-')
          ?.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          ?.join('-')
      )
      ?.join(' ');
  }

  exportAasinetImport(): void {
    const workbook: Workbook = new Workbook();
    const data = this.importAasinet;
    const worksheet = workbook.addWorksheet('Importador Aasinet');

    if (!data || data.length === 0) return;
    const headers = Object.keys(data[0]);
    worksheet.addRow(headers);
    data.forEach((item) => {
      const rowData = headers.map((key) => item[key]);
      worksheet.addRow(rowData);
    });
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      this.saveExcelFile(
        blob,
        'import_aasinet_' +
          this.entitySelected.code +
          '_' +
          this.filter.year +
          '_' +
          this.filter.version +
          '_' +
          this.getDate()
      );
    });
  }

  headerAccounts(accountPlan) {
    return accountPlan.map((acc) => acc.departamentCode);
  }

  styleHeaderRow(worksheet, rowNumber: number): void {
    const headerRow = worksheet.getRow(rowNumber);
    worksheet.getRow(rowNumber).height = 25;
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFBFBFBF' }, // gris claro
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'medium' },
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
      };
    });
  }

  styleDataRow(row, accountStartIndex): void {
    row.eachCell((cell, colNumber) => {
      // Aplicar bordes a todas las celdas
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        left: { style: 'medium' },
        right: { style: 'medium' },
      };

      // Si la columna es una cuenta, aplicar formato numérico
      if (colNumber >= accountStartIndex) {
        cell.numFmt = '#,##0';
      }
    });
  }

  autoAdjustColumns(worksheet): void {
    worksheet.columns.forEach((column) => {
      let max = 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const len = cell.value ? cell.value.toString().length : 10;
        if (len > max) max = len;
      });
      column.width = max + 2;
    });
  }

  styleSubtotalRows(worksheet, rowNumber: number): void {
    const subtotalRow = worksheet.getRow(rowNumber);
    subtotalRow.height = 25;
    subtotalRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFBFBFBF' }, // gris claro
      };
      cell.alignment = { vertical: 'middle', horizontal: 'right' };
      cell.border = {
        top: { style: 'medium' },
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
      };
      cell.numFmt = '#,##0';
    });
  }

  addSubtotalRow(worksheet, startCol, rowNumber, mergeCol): void {
    const lastRowNumber = worksheet.lastRow.number;
    const subtotalRow = worksheet.addRow([]);
    if (mergeCol >= 1) {
      worksheet.mergeCells(subtotalRow.number, 1, subtotalRow.number, mergeCol);
      const labelCell = worksheet.getCell(subtotalRow.number, 1);
      labelCell.value = 'SUBTOTAL';
      labelCell.alignment = { horizontal: 'center', vertical: 'middle' };
      labelCell.font = { bold: true };
    }
    for (let col = startCol; col <= worksheet.columnCount; col++) {
      const colLetter = worksheet.getColumn(col).letter;
      const cell = subtotalRow.getCell(col);
      cell.value = {
        formula: `SUM(${colLetter}${rowNumber}:${colLetter}${lastRowNumber})`,
        result: null,
      };
      cell.font = { bold: true };
    }
  }

  createSheet(workbook: Workbook, title, headers, data, accounts) {
    const totalColumns = 4 + accounts.length;
    const worksheet = workbook.addWorksheet(title);

    // Título
    worksheet.mergeCells(1, 1, 1, totalColumns);
    const titleCell = worksheet.getCell('A1');
    titleCell.value = `${title.toUpperCase()}`;
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    titleCell.font = { bold: true };
    worksheet.getRow(1).height = 40;
    for (let col = 1; col <= totalColumns; col++) {
      worksheet.getCell(1, col).border = {
        top: { style: 'medium' },
        left: { style: 'medium' },
        bottom: { style: 'medium' },
        right: { style: 'medium' },
      };
    }

    // Encabezados: nombres de cuentas
    worksheet.mergeCells(2, 1, 2, 4);
    worksheet.getCell('A2').value = 'Departamentos ';
    worksheet.getCell('A2').alignment = {
      horizontal: 'center',
      vertical: 'middle',
    };
    accounts.forEach((acc, index) => {
      worksheet.getCell(2, 5 + index).value = this.capitalize(
        acc.departamentDisplayName
      );
    });

    // Encabezado principal
    worksheet.addRow(headers);
    this.styleHeaderRow(worksheet, 2);
    this.styleHeaderRow(worksheet, 3);
    // Datos
    data.forEach((obj) => {
      const row = worksheet.addRow(Object.values(obj));
      this.styleDataRow(row, 3);
    });
    this.addSubtotalRow(worksheet, 3, 3, 2);
    this.styleSubtotalRows(worksheet, worksheet.lastRow.number);

    this.autoAdjustColumns(worksheet);
  }

  exportToExcel(): void {
    const workbook = new Workbook();
    const data = this.dataExcel(this.accounts, this.fieldName);
    this.createSheet(
      workbook,
      this.accounts[0].itemName,
      this.headers(),
      data,
      this.fieldName
    );
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      this.saveExcelFile(
        blob,
        this.accounts[0]?.itemName + '_' + this.getDate()
      );
    });
  }

  dataExcel(data, plan) {
    const result = data.map((e) => {
      const fixedDataValues = [
        e.subAccountCode
          ? e.accountCode + ' / ' + e.subAccountCode
          : e.accountCode,
        e.accountDisplayName,
        e.diezmo ?? 0,
        e.noDiezmo ?? 0,
      ];
      const accountsValues = this.flattenAccounts(e.departaments, plan);

      const result2 = [...fixedDataValues, ...accountsValues];
      return result2;
    });
    return result;
  }

  flattenAccounts(accounts, plan) {
    const accountMap = {};
    for (const acc of accounts) {
      accountMap[acc.departamentCode.toString()] = Number(acc.value ?? 0);
    }
    const accountsValues = plan.map(
      (code) => accountMap[code.departamentCode] ?? 0
    );
    return accountsValues;
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
    saveAs(data, `${fileName}.xlsx`);
  }

  /**Obtener la fecha en formato 04/12/2024 09:36:44  */
  getDate() {
    let date = new Date();
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    } as const; // Opciones para la fecha
    const formattedDate = date.toLocaleDateString('es-ES', options); // Formato DD-MM-YYYY
    const formattedTime = date.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }); // Formato HH:mm:ss
    return `${formattedDate}_${formattedTime}`;
  }

  getDomain(){
    const domian=window.location.hostname.split('.')
    return domian[0]+'.uch'
  }



  addHeaderPDF(doc,text,startY){
    autoTable(doc, {
      startY: 35,
      head: [
        [
          { content: 'Iglesia Adventista del Séptimo Día', styles: { fontStyle: 'normal', fontSize: 10 } },
        ],
        [
          { content: this.entitySelected?.name+'', styles: { fontStyle: 'italic', fontSize: 10 } },
        ]
      ],
      theme: 'plain',
      headStyles: {
        halign: 'center', 
        cellPadding: 1,   
      },
      margin: { left: 0, right: 0 },
      tableWidth: 'auto', 
      didDrawPage: function (data) {
        startY = data.cursor.y;
      },
    });
    autoTable(doc, {
      startY: startY+5,
      head: [
        [
          { content: text.title, styles: { fontStyle: 'bold', fontSize: 11 } },
        ],
        [
          { content: text.subTitle, styles: { fontStyle: 'bold', fontSize: 9 } },
        ]
      ],
      theme: 'plain',
      headStyles: {
        halign: 'center', 
        cellPadding: 0.3,   
      },
      margin: { left: 0, right: 0 },
      tableWidth: 'auto', 
      didDrawPage: function (data) {
        startY = data.cursor.y;
      },
    });
    return startY;
  }


  addHeaderPDFIASD(doc,text,startY){
     
   autoTable(doc, {
      startY: startY,
      head: [
        [
          { content: text.title, styles: { fontStyle: 'bold', fontSize: 11 } },
        ]
      ],
      theme: 'plain',
      headStyles: {
        halign: 'center', 
        cellPadding: 0.3,   
      },
      margin: { left: 0, right: 0 },
      tableWidth: 'auto', 
      didDrawPage: function (data) {
        startY = data.cursor.y;
      },
    });
   autoTable(doc, {
      startY: startY,
      head: [
        [
          { content: text.subTitle+'', styles: { fontStyle: 'bold', fontSize: 8 } },
        ]
      ],
      theme: 'plain',
      headStyles: {
        halign: 'center', 
        cellPadding: 1,   
      },
      margin: { left: 0, right: 0 },
      tableWidth: 'auto', 
      didDrawPage: function (data) {
        startY = data.cursor.y;
      },
    });
     return startY;
  }


  addHtmlTable(doc, idHtml, startY, pdfWidth, lineOffsetTop = 41, columnStyles, fontStyle: 'normal' | 'bold' = 'normal') {
    autoTable(doc, {
      html: idHtml,
      startY: startY + 25,
      theme: 'plain',
      bodyStyles: { fontSize: 8, cellPadding: 2,fontStyle: fontStyle },
      headStyles: { cellPadding: 2 },
      footStyles: { cellPadding: 2 },
      
      useCss: false,
      tableWidth: 'wrap',
      columnStyles: columnStyles,
      didParseCell: this.customDidParseCell,
      styles: { fontSize: 8 },
      didDrawPage: (data) => {
        doc.line(35, startY + lineOffsetTop, pdfWidth, startY + lineOffsetTop);
        startY = data.cursor.y + 1;
        doc.line(35, startY - 15, pdfWidth, startY - 15);
      },
    });
    return startY;
  }


  addTableHeaderPDF(doc, idHtml, startY, pdfWidth) {
    return this.addHtmlTable(doc, idHtml, startY, pdfWidth, 51,this.columnStyles);
  }
  
  addTablePDF(doc, idHtml, startY, pdfWidth, fontStyle: 'normal' | 'bold' = 'normal') {    
    return this.addHtmlTable(doc, idHtml, startY, pdfWidth, 38,this.columnStyles,fontStyle);
  }
  

  addFooterPDF(doc,pdfWidth){
    autoTable(doc, {
      startY: 732,
      body: [['Impreso:' + this.getDate(), 'Usuario:'+this.user.mail, 'Sistema:'+this.getDomain(), 'Página 1 de 1']],
      theme: 'plain',
      bodyStyles: { fontSize:7,cellPadding:0.3 },
      tableWidth: 'auto',
      didDrawPage:  data=> {
        doc.line(35, 721 , pdfWidth, 721 );      
      },
    });   
  }


 exportPDF() {
    const  logo = new Image();
    const doc = new jsPDF('p', 'pt', 'letter');
    let year = this.filter.year;
    let title = 'Presupuesto '+year+' '+this.entitySelected?.code;
    let subTitle=' Resumen General - Version - '+this.filter.version;
    const pdfWidth = (doc.internal.pageSize.getWidth())-60;
    let startY =30;
    if(this.entitySelected?.group=='IASD'){
      startY=83;
      logo.src = 'assets/img/campus/'+this.entitySelected.code+'.jpg';   
      doc.addImage(logo, 'JPG', 40, 35, 140, 50,undefined, "FAST", 0.15);
      startY=this.addHeaderPDFIASD(doc,{title:title,subTitle:subTitle},startY); 
      startY=startY+5;
      startY=this.addTableHeaderPDF(doc,'#table-revenue',startY-10,pdfWidth);
      startY=this.addTablePDF(doc,'#table-expense',startY,pdfWidth);
      startY=this.addTablePDF(doc,'#table-margin',startY,pdfWidth,'bold');
      startY=startY+10;
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(8);
      doc.text('* El % de egresos se calcula en base al ingreso diezmo', 40, startY + 15); 
      startY += 10; 
    }else{
      startY=this.addHeaderPDF(doc,{title:title,subTitle:subTitle},startY); 
      startY=this.addTableHeaderPDF(doc,'#table-revenue',startY-5,pdfWidth);
      startY=this.addTablePDF(doc,'#table-expense',startY,pdfWidth);
      startY=this.addTablePDF(doc,'#table-margin',startY,pdfWidth,'bold');
    }
    this.addFooterPDF(doc,pdfWidth); 
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    this.pdfSrc=this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl)
    this.open(this.preview) 

  }
}  
